import BannerRefferalHeader from './banner-refferal-header';

export default BannerRefferalHeader;
